import React from 'react';
export function TrustBar() {
  const trustItems = ['Free Commercial Estimates', 'Storefront Glass Specialists', 'Office Glass Walls & Dividers', 'Contract Glazing Available', 'Fabrication & Installation', 'Repair & Replacement', 'Service & Maintenance', 'Howell, Ann Arbor & Novi'];
  return <div className="bg-white border-y border-neutral-200 py-4" data-id="element-879" data-mp="16vf98kclyuj8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-880" data-mp="j4t1ku6inc9r">
        <div className="flex flex-wrap justify-center gap-2 md:gap-3" data-id="element-881" data-mp="j75svxy5yyzh">
          {trustItems.map((item, idx) => <div key={idx} className="flex items-center gap-2 text-neutral-700 text-xs sm:text-sm font-medium px-3 py-1.5 whitespace-nowrap font-sans anim-fade-up" style={{
          animationDelay: `${idx * 0.05}s`
        }} data-id="element-882" data-mp="s60v6yy37oxi" data-mpi={idx}>
              <div className="w-1.5 h-1.5 rounded-full bg-primary-600" data-id="element-883" data-mp="1zjkud87kqljl"></div>
              {item}
            </div>)}
        </div>
      </div>
    </div>;
}